import { format, addDays } from 'date-fns'

const today = () => format(new Date(), 'yyyy-MM-dd')
const inDays = (n) => format(addDays(new Date(), n), 'yyyy-MM-dd')

// now = today + overdue, soon = tomorrow through 7 days, later = 7+ days
const BUCKET_PARAMS = {
  now: () => ({ due_before: today() }),
  soon: () => ({ due_after: today(), due_before: inDays(7) }),
  later: () => ({ due_after: inDays(7) }),
}

export const state = () => ({
  now: { items: [], currentPage: 1, lastPage: 1, total: 0 },
  soon: { items: [], currentPage: 1, lastPage: 1, total: 0 },
  later: { items: [], currentPage: 1, lastPage: 1, total: 0 },
  personalReminders: [],
  customerReminders: [],
  // one token per bucket so switching consultants mid-flight cancels only the relevant requests
  cancelTokens: { now: null, soon: null, later: null },
})

export const actions = {
  async loadBucket({ commit, state }, { bucket, userId, page = 1 }) {
    const url = userId ? `users/${userId}/reminders` : 'reminders'

    if (state.cancelTokens[bucket]) {
      state.cancelTokens[bucket].cancel('Canceled due to new request.')
    }
    const cancelToken = this.$axios.CancelToken.source()
    commit('setCancelToken', { bucket, token: cancelToken })

    try {
      const response = await this.$axios.get(url, {
        params: { ...BUCKET_PARAMS[bucket](), page },
        cancelToken: cancelToken.token,
      })
      commit('setCancelToken', { bucket, token: null })

      const { data, meta } = response.data
      commit('setBucket', {
        bucket,
        items: data,
        currentPage: meta.current_page,
        lastPage: meta.last_page,
        total: meta.total,
      })
    } catch (error) {
      commit('setCancelToken', { bucket, token: null })
      if (!this.$axios.isCancel(error)) {
        console.error('Request failed:', error)
      }
    }
  },

  loadAll({ dispatch }, userId) {
    return Promise.all([
      dispatch('loadBucket', { bucket: 'now', userId }),
      dispatch('loadBucket', { bucket: 'soon', userId }),
      dispatch('loadBucket', { bucket: 'later', userId }),
    ])
  },

  async loadPersonalReminders({ commit, rootGetters }) {
    const { data } = await this.$axios.$get(
      `users/${rootGetters['user/currentUser'].id}/reminders`,
      { params: { due_before: today() } }
    )
    commit('setPersonalReminders', data)
  },

  async create(_, { userId, data }) {
    const reminder = await this.$axios.$post(`users/${userId}/reminders`, data)
    return reminder.data
  },

  async update(_, { userId, id, data }) {
    const reminder = await this.$axios.$patch(
      `users/${userId}/reminders/${id}`,
      data
    )
    return reminder.data
  },

  async loadCustomerReminders({ commit }, customerId) {
    const { data } = await this.$axios.$get(`customers/${customerId}/reminders`)
    commit('setCustomerReminders', data)
  },
}

export const mutations = {
  setBucket(state, { bucket, items, currentPage, lastPage, total }) {
    state[bucket] = { items, currentPage, lastPage, total }
  },
  setPersonalReminders(state, value) {
    state.personalReminders = value
  },
  setCustomerReminders(state, value) {
    state.customerReminders = value
  },
  // spread required — Vue 2 won't detect direct property assignment on nested objects
  setCancelToken(state, { bucket, token }) {
    state.cancelTokens = { ...state.cancelTokens, [bucket]: token }
  },
}

// kept for WelcomeBanner.vue which maps these getters directly
export const getters = {
  nowReminders(state) {
    return state.now.items
  },
  soonReminders(state) {
    return state.soon.items
  },
  laterReminders(state) {
    return state.later.items
  },
}
